import { navigateToUrl } from 'single-spa'
import { UsuaPerfilAtivo } from '../interfaces/user'
import { CommunicationService } from '../services/communication.service'
// @ts-ignore
import { AuthService, LocalStorageService, APPS as APP_INFO, ToolbarService } from '@cosmos/utilities';

export class ChangeAppEvent {
  readonly REQUEST_EVENT_NAME = 'requestChangeApp'
  readonly RESPONSE_EVENT_NAME = 'changeApp'
  static changeAppEvent: ChangeAppEvent

  private constructor() {
    this.load()
  }

  static init(): ChangeAppEvent {
    if (!ChangeAppEvent.changeAppEvent) {
      ChangeAppEvent.changeAppEvent = new ChangeAppEvent()
    }
    return ChangeAppEvent.changeAppEvent
  }

  static destroy() {
  }

  load() {
    const communicationService = CommunicationService.singleton()
    communicationService.receiveCustomEvent(
      this.REQUEST_EVENT_NAME,
      this.requestChangeApp
    )
  }

  requestChangeApp: EventListener = async (event: CustomEvent) => {
    const communicationService = CommunicationService.singleton()
    try {
      const sistAtivoToken: string = event.detail.sist_token_acesso
      const redirectPath: string = event.detail.redirect_path
      const redirectToPage: string = event.detail.redirect_page

      const sistDestino: AppInfoDetails | any = Object.values(APP_INFO).find((app : AppInfoDetails)=> app.sspa_name && app.chave_sistema == sistAtivoToken)
      
      // verifica se aplicação de destino não é um micro framework
      if(sistDestino === undefined) {
        navigateToUrl(event.detail.auth_url)
        return
      }

      const localStorageService = LocalStorageService.singleton()
      const authService = new AuthService();

      const token = localStorageService.getItem('token')
      const userProfile: UsuaPerfilAtivo =
        localStorageService.getItem('usua_perfil_ativo')

      const userProfileReq = await authService.user(
        {
          token,
          chave_sistema: sistAtivoToken,
          inst_codigo: userProfile.instituicao.inst_codigo,
          usua_tipo_id: userProfile.usua_tipo_id
        }
      )

      //mantendo dados de autorização de notificações ao trocar de app
      const userData = localStorageService.getItem("usuario");
      let userProfileData: UsuaPerfilAtivo = userProfileReq.data.data
      userProfileData['usuario'].sou_autorizador = userData.sou_autorizador;

      localStorageService.setItem(sistAtivoToken, {...userProfileData, token}, true)

      ToolbarService.singleton().setToolbarToDefault()

      let sistRoute = `/${sistDestino.route}/app` + (redirectPath ? event.detail.auth_url : '')

      if(redirectToPage) {
        sistRoute = `/${sistDestino.route}/` + redirectToPage;
      }

      if (sistDestino.chave_sistema === APP_INFO['led'].chave_sistema) {
        // Led precisa de autenticação interna (SCAO), portanto deve-se passar parâmetros de acesso
        const urlObj = new URL(event.detail.auth_url)
        const path = urlObj.pathname
        const parametros = urlObj.search
        sistRoute = `${path}${parametros}`
      }

      navigateToUrl(sistRoute)
      
      communicationService.emitCustomEvent(this.RESPONSE_EVENT_NAME, {})
      communicationService.emitCustomEvent("changeLayout", {toolbar: false, sidenav: false})
      
    } catch (error) {
      console.log(error)
      communicationService.emitCustomEvent('requestLogout', null)
    }
  }
}
